import React from 'react'

const GetStarted = () => {
  return (
    <>
    
    </>
  )
}

export default GetStarted